export default {
    home: [
        {
            name: 'Neubau Zentrallager ELAG Gerüste AG, Worb',
            isBlank: false,
            isLivecamImage: false,
            image: 'elag_geruste/title.jpeg',
            companyName: 'Zentrallager ELAG Gerüste AG',
            responsibility: 'Neubau',
            images: [
                'https://player.vimeo.com/video/764936670?color=ff0509&title=0&byline=0&portrait=0'
            ]
        },
        {
            name: 'Neubau ALLOPA, Zürich',
            isBlank: false,
            isLivecamImage: false,
            image: 'allopa/title.jpeg',
            companyName: 'ALLOPA',
            responsibility: 'Neubau',
            images: [
                'https://player.vimeo.com/video/764936593?color=ff0509&title=0&byline=0&portrait=0'
            ]
        },
        {
            isBlank: true
        },
        {
            name: 'KVA Weinfelden',
            isBlank: false,
            image: 'raz_weinfelden/title.jpg',
            isLivecamImage: false,
            livecamLatestURL: '',
            livecamURL: '',
            companyName: 'KVA Weinfelden',
            responsibility: 'Neubau',
            images: [
                'https://player.vimeo.com/video/243880246?color=ff0509&title=0&byline=0&portrait=0',
                'https://player.vimeo.com/video/276020799?color=ff0509&title=0&byline=0&portrait=0',
                'raz_weinfelden/01.jpg'
            ],
            cams: ['https://feed.yellow.webcam/feed/2CRPJ2T14']
        },
        {
            name: 'Alpa Bern',
            isBlank: false,
            image: 'alpa_bern/title.jpg',
            isLivecamImage: false,
            companyName: 'Alpa Bern',
            responsibility: 'Neubau',
            images: [
                'alpa_bern/01.jpg',
                'alpa_bern/02.jpg',
                'alpa_bern/03.jpg',
                'alpa_bern/04.jpg',
                'alpa_bern/05.jpg',
                'alpa_bern/06.jpg',
                'alpa_bern/07.jpg',
                'https://player.vimeo.com/video/237076327?color=ffffff&byline=0&portrait=0',
                'https://player.vimeo.com/video/257483684'
            ]
        },
        {
            name: 'Eggenberger',
            isBlank: false,
            image: 'eggenberger/title.jpg',
            isLivecamImage: false,
            companyName: 'Eggenberger',
            responsibility: 'Neubau',
            images: [
                'eggenberger/01.jpg',
                'eggenberger/02.jpg',
                'eggenberger/03.jpg',
                'eggenberger/04.jpg',
                'eggenberger/05.jpg',
                'eggenberger/06.jpg'
            ]
        },
        {
            name: 'K. Müller AG',
            isBlank: false,
            image: 'k_mueller/title.jpg',
            isLivecamImage: false,
            companyName: 'K. Müller AG',
            responsibility: 'Neubau',
            images: [
                'k_mueller/01.jpg',
                'k_mueller/02.jpg',
                'k_mueller/03.jpg',
                'k_mueller/04.jpg',
                'k_mueller/05.jpg',
                'k_mueller/06.jpg',
                'k_mueller/07.jpg',
                'https://player.vimeo.com/video/257482486',
                'https://player.vimeo.com/video/257483121'
            ]
        },
        {
            name: 'MZ Brunegg',
            isBlank: false,
            image: 'mz_brunegg/title.jpg',
            isLivecamImage: false,
            companyName: 'MZ Brunegg',
            responsibility: 'Neubau',
            images: [
                'mz_brunegg/01.jpg',
                'mz_brunegg/02.jpg',
                'mz_brunegg/03.jpg',
                'mz_brunegg/04.jpg',
                'mz_brunegg/05.jpg',
                'mz_brunegg/06.jpg'
            ]
        },
        {
            name: 'Norline',
            isBlank: false,
            image: 'norline/title.jpg',
            isLivecamImage: false,
            companyName: 'Norline',
            responsibility: 'Neubau',
            images: [
                'norline/01.jpg',
                'norline/02.jpg',
                'norline/03.jpg',
                'norline/04.jpg'
            ]
        },
        {
            name: 'RAZ Frauenfeld',
            isBlank: false,
            image: 'raz_frauenfeld/title.jpg',
            isLivecamImage: false,
            companyName: 'RAZ Frauenfeld',
            responsibility: 'Neubau',
            images: [
                'raz_frauenfeld/01.jpg',
                'raz_frauenfeld/02.jpg',
                'raz_frauenfeld/03.jpg',
                'raz_frauenfeld/04.jpg',
                'raz_frauenfeld/05.jpg',
                'raz_frauenfeld/06.jpg',
                'raz_frauenfeld/07.jpg',
                'raz_frauenfeld/08.jpg'
            ]
        },
        {
            name: 'Hugelshofer',
            isBlank: false,
            image: 'hugelshofer/title.jpg',
            isLivecamImage: false,
            companyName: 'Hugelshofer',
            responsibility: 'Neubau',
            images: [
                'hugelshofer/01.jpg',
                'hugelshofer/02.jpg',
                'hugelshofer/03.jpg'
            ]
        },
        {
            name: 'Häusle',
            isBlank: false,
            image: 'haeusle/title.jpg',
            isLivecamImage: false,
            companyName: 'Häusle',
            responsibility: 'Neubau',
            images: [
                'haeusle/01.jpg',
                'haeusle/02.jpg',
                'haeusle/03.jpg',
                'haeusle/04.jpg',
                'haeusle/05.jpg'
            ]
        },
        {
            name: 'Innorecycling / Innoplastics',
            isBlank: false,
            image: 'inno/title.jpg',
            isLivecamImage: false,
            companyName: 'Innorecycling / Innoplastics',
            responsibility: 'Neubau',
            images: [
                'inno/01.jpg',
                'inno/02.jpg',
                'inno/03.jpg',
                'inno/04.jpg',
                'inno/05.jpg',
                'inno/06.jpg',
                'inno/07.jpg',
                'inno/08.jpg',
                'inno/09.jpg',
                'inno/10.jpg',
                'inno/11.jpg'
            ]
        },
        {
            name: 'MF Hügler',
            isBlank: false,
            image: 'huegler/title.jpg',
            isLivecamImage: false,
            companyName: 'MF Hügler',
            responsibility: 'Neubau',
            images: [
                'huegler/01.jpg',
                'huegler/02.jpg',
                'huegler/03.jpg',
                'huegler/04.jpg',
                'huegler/05.jpg',
                'huegler/06.jpg',
                'huegler/07.jpg',
                'huegler/08.jpg',
                'huegler/09.jpg',
                'huegler/10.jpg',
                'huegler/11.jpg',
                'huegler/12.jpg'
            ]
        },
        {
            name: 'Loacker',
            isBlank: false,
            image: 'loacker/title.jpg',
            isLivecamImage: false,
            companyName: 'Loacker',
            responsibility: 'Neubau / Erweiterung',
            images: [
                'loacker/01.jpg',
                'loacker/02.jpg',
                'loacker/03.jpg',
                'loacker/04.jpg',
                'loacker/05.jpg'
            ]
        },
        {
            name: 'Bruderertrans AG / Drisa',
            isBlank: false,
            image: 'bruderertrans/title.jpg',
            isLivecamImage: false,
            companyName: 'Bruderertrans AG / Drisa',
            responsibility: 'Neubau',
            images: ['bruderertrans/01.jpg', 'bruderertrans/02.jpg']
        },
        {
            name: 'Peter Schmid Baudienstleistungen AG',
            isBlank: false,
            image: 'peterschmid/title.jpg',
            isLivecamImage: false,
            companyName: 'Peter Schmid Baudienstleistungen AG',
            responsibility: 'Neubau',
            images: [
                'peterschmid/01.jpg',
                'peterschmid/02.jpg',
                'peterschmid/03.jpg',
                'peterschmid/04.jpg'
            ]
        },
        {
            name: 'Immark AG',
            isBlank: false,
            image: 'immark/title.jpg',
            isLivecamImage: false,
            companyName: 'Immark AG',
            responsibility: 'Neubau',
            images: ['immark/01.jpg', 'immark/02.jpg', 'immark/03.jpg']
        }
    ],
    references: [
        {
            image: 'erz.png',
            companyName: 'ERZ Zürich',
            responsibility: 'Neubau'
        },
        {
            image: 'kva.png',
            companyName: 'KVA Weinfelden',
            responsibility: 'Neubau'
        },
        {
            image: 'hugelshofer.png',
            companyName: 'Hugelshofer',
            responsibility: 'Neubau'
        },
        {
            image: 'alpabern.png',
            companyName: 'Alpa Bern',
            responsibility: 'Neubau'
        },
        {
            image: 'papirec.png',
            companyName: 'Papirec',
            responsibility: 'Neubau'
        },
        {
            image: 'datarec.png',
            companyName: 'Datarec',
            responsibility: 'Neubau'
        },
        {
            image: 'mueller.png',
            companyName: 'Müller',
            responsibility: 'Neubau'
        },
        {
            image: 'model.png',
            companyName: 'Model',
            responsibility: 'Neubau'
        },
        {
            image: 'toshiba.png',
            companyName: 'Toshiba',
            responsibility: 'Neubau'
        },
        {
            image: 'swissterminal.png',
            companyName: 'Swiss Terminal',
            responsibility: 'Neubau'
        },
        {
            image: 'spross.png',
            companyName: 'Spross',
            responsibility: 'Neubau'
        },
        {
            image: 'loacker.png',
            companyName: 'Loacker',
            responsibility: 'Neubau'
        },
        {
            image: 'eggenberger.png',
            companyName: 'Eggenberger',
            responsibility: 'Neubau'
        },
        {
            image: 'immark.png',
            companyName: 'Immark AG',
            responsibility: 'Neubau'
        },
        {
            image: 'drisa.png',
            companyName: 'Drisa',
            responsibility: 'Neubau'
        },
        {
            image: 'innoplastics.png',
            companyName: 'Inno Plastics',
            responsibility: 'Neubau'
        },
        {
            image: 'innorecycling.png',
            companyName: 'Inno Recycling',
            responsibility: 'Neubau'
        },

        {
            image: 'swissglas.png',
            companyName: 'Swiss Glas',
            responsibility: 'Neubau'
        },
        {
            image: 'swissrepair.png',
            companyName: 'Swiss Repair',
            responsibility: 'Neubau'
        },
        {
            image: 'deutschepost.png',
            companyName: 'Deutsche Post',
            responsibility: 'Neubau'
        },
        {
            image: 'lapp.png',
            companyName: 'Lapp Engineering',
            responsibility: 'Neubau'
        },
        {
            image: 'entsorgungsfachmarkt.png',
            companyName: 'Entsorgungsfachmarkt',
            responsibility: 'Neubau'
        },
        {
            image: 'solenthaler.png',
            companyName: 'Solenthaler',
            responsibility: 'Neubau'
        },
        {
            image: 'norline.png',
            companyName: 'Norline AG',
            responsibility: 'Neubau'
        },
        {
            image: 'mz.png',
            companyName: 'MZ Entsorgungs Management AG',
            responsibility: 'Neubau'
        },
        {
            image: 'die-entsorger.png',
            companyName: 'die-entsorger.ch',
            responsibility: 'Neubau'
        },
        {
            image: 'huegler.png',
            companyName: 'MF Hügler',
            responsibility: 'Neubau'
        },
        {
            image: 'daetwiler.png',
            companyName: 'Daetwiler',
            responsibility: 'Neubau'
        },
        {
            image: 'kaufmann.png',
            companyName: 'Kaufmann Recycling AG',
            responsibility: 'Neubau'
        },
        {
            image: 'haeusle.png',
            companyName: 'Häusle Schweiz AG',
            responsibility: 'Neubau'
        },
        {
            image: 'peterschmid.png',
            companyName: 'Peter Schmid',
            responsibility: 'Neubau'
        },
        {
            image: 'bruderertrans.png',
            companyName: 'Bruderertrans AG',
            responsibility: 'Neubau'
        },
        {
            image: 'nes.png',
            companyName: 'NES',
            responsibility: 'Neubau'
        },
        {
            image: 'keller.png',
            companyName: 'Keller Recycling AG',
            responsibility: 'Neubau'
        },
        {
            image: 'thuer.png',
            companyName: 'Thür',
            responsibility: 'Neubau'
        },
        {
            image: 'landolt.png',
            companyName: 'Landolt',
            responsibility: 'Neubau'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/assets/data/siteconfig.js